// - Import external components
import * as redux from 'redux';
import thunk from 'redux-thunk';
import { routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import createSagaMiddleware, { END } from 'redux-saga';
import { rootReducer } from 'store/reducers';
import { fromJS } from 'immutable';
// Create a history of your choosing (we're using a browser history in this case)
export var history = createHistory();
// - Build the middleware for intercepting and dispatching navigation actions
var sagaMiddleware = createSagaMiddleware();
// - initial state
var initialState = {};
// - Config and create store of redux
var store = redux.createStore(rootReducer, fromJS(initialState), redux.compose(redux.applyMiddleware(thunk, routerMiddleware(history), sagaMiddleware)));
export default { store: store, runSaga: sagaMiddleware.run, customDispatch: function (disp) { return store.dispatch(disp); }, close: function () { return store.dispatch(END); }, history: history };



//////////////////
// WEBPACK FOOTER
// ./src/store/configureStore.prod.ts
// module id = 593
// module chunks = 50